// @core/api/endpoints/platform/discover_platforms.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DiscoverPlatformsResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Discover platforms in registry
 * Searches the central discovery registry for platforms available for federation. Supports filtering by region, products, and status.
 */
export async function DiscoverPlatforms(
  params?: {
  },
  options?: RequestOptions
): Promise<DiscoverPlatformsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/registry/platforms`;
  const requestOptions = options;
  return client.get<DiscoverPlatformsResponse>(requestPath, { ...requestOptions, params });
}
